import { AlertCircle } from "lucide-react";

export function SectionError({ message, onRetry }) {
  return (
    <div className="flex items-center gap-3 rounded-md border border-error/30 bg-error/5 p-4 text-sm text-error">
      <AlertCircle size={18} aria-hidden="true" />
      <span>{message}</span>
      <button
        type="button"
        className="ml-auto font-semibold underline underline-offset-2"
        onClick={onRetry}
      >
        Tentar novamente
      </button>
    </div>
  );
}
